<form [formGroup]="addForm" (ngSubmit) = "onSubmit()">
    <p-dialog  [(visible)]="displayDialog" 
      [modal]="true" 
      [positionTop]="50" 
      [maximizable]="true"
      [contentStyle]="{'min-width':'500px', 'min-height':'266px'}"
      (onHide)="dialogHide()" 
      (onShow)="dialogShow()">
      <p-header>
        <b>Add Asset Group</b>
      </p-header>      
        <div class="ui-grid ui-grid-responsive formcontainer">           
          <div class="formgroup">
             <div class="ui-grid-row">
              <div class="ui-grid-col-12">
                <label for="RelationshipGroupName">Asset Group Name</label>
              </div>
            </div>
            <div class="ui-grid-row">
              <div class="ui-grid-col-12">
                <input type="text" pInputText formControlName="RelationshipGroupName" [style]="{'width':'500px'}" (blur)="onRelationshipGroupNameChange()" >
              </div>
            </div>
            <div *ngIf="relationshipGroupNameControl.invalid 
                && (relationshipGroupNameControl.dirty || relationshipGroupNameControl.touched) 
                && relationshipGroupNameControl.errors.required" class="custom-required">
                Asset Group Name is required.
            </div>
            <div *ngIf="assetGroupVerification" class="custom-required">Verification in progress..</div>
            <div *ngIf="assetGroupExists" class="custom-required">Asset Group Name already exists</div>          
          </div>
          <div class="formgroup">
            <div class="ui-grid-row">
              <div class="ui-grid-col-12">
                <label for="Relationship">Partnership</label>    
              </div>
            </div>
            <div class="ui-grid-row">
              <div class="ui-grid-col-12">
                <p-dropdown [options]="relationship" optionLabel="Company.Name" formControlName="RelationshipId" placeholder="Select One" [style]="{'width':'250px'}" (onChange)="relationshipChange()"></p-dropdown>
                <div *ngIf="relationshipControl.invalid 
                && (relationshipControl.dirty || relationshipControl.touched) 
                && relationshipControl.errors.required" class="custom-required">
                Please select Partnership.
            </div>
              </div>
            </div>            
          </div>
          <div class="formgroup">
            <div class="ui-grid-row">
              <div class="ui-grid-col-12">
                  <label for="AssetId">Asset ID(s)</label>
              </div>
            </div>
            <div class="ui-grid-row">
              <div class="ui-grid-col-12">                 
                <app-asset-id-dropdown
                  [relationshipId]=relationshipControl.value.Id 
                  [relationshipDataItemSelected]="relationshipDataItemSelected"
                  defaultLabel="Select Asset ID(s)" 
                  filterPlaceHolder=""
                  formControlName="Items">
                </app-asset-id-dropdown>                
                <div *ngIf="itemsControl.invalid 
                    && itemsControl.touched
                    && itemsControl.errors.required" class="custom-required">
                    Please select Asset ID(s).
                </div>                
              </div>
            </div>            
          </div>
          <div class="formgroup">
            <div class="ui-grid-row">
              <div class="ui-grid-col-12">
                <label for="Users" >Associated Users with this Group</label>
              </div>
            </div>
            <div class="ui-grid-row">
              <div class="ui-grid-col-12">
                <p-multiSelect 
                  [options]="assignedUsers"
                  defaultLabel="Select Associated Users"
                  [filterPlaceHolder]=""
                  formControlName="Assigned"                  
                  optionLabel="FullName">
                </p-multiSelect>                
              </div>
            </div>
          </div>
        </div>
      <p-footer>
          <button pButton type="button" label="Cancel" class="ui-button-secondary" (click)="dialogHide()"></button>
          <button pButton type="submit" label="{{processing ? 'Processing' : 'Save'}}" [disabled]="processing || addForm.invalid || assetGroupExists || assetGroupVerification"></button>
      </p-footer>
    </p-dialog>
    </form>

